import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class MenuService {
    private urlModulo = `${environment.urlAPI}/menu`;

    constructor(private http: HttpClient) { }

    /**
     * Recupera o menu do usuário pelo ID
     */
    public getMenu(uid: number): Promise<any> {
        const params = new HttpParams().set('uid', uid.toString());
        
        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}`, { params })
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.menu);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }
}


// WEBPACK FOOTER //
// /app/src/app/services/menu.service.ts